/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { slackDirectoryConnectionsBegin } from "../funcs/slackDirectoryConnectionsBegin.js";
import { slackDirectoryConnectionsDisconnect } from "../funcs/slackDirectoryConnectionsDisconnect.js";
import { slackDirectoryConnectionsGetMember } from "../funcs/slackDirectoryConnectionsGetMember.js";
import { slackDirectoryConnectionsList } from "../funcs/slackDirectoryConnectionsList.js";
import { slackDirectoryConnectionsListMembers } from "../funcs/slackDirectoryConnectionsListMembers.js";
import { slackDirectoryConnectionsListPersonAccounts } from "../funcs/slackDirectoryConnectionsListPersonAccounts.js";
import { slackDirectoryConnectionsSetMapping } from "../funcs/slackDirectoryConnectionsSetMapping.js";
import { slackDirectoryConnectionsSync } from "../funcs/slackDirectoryConnectionsSync.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { BeginResponseBody } from "../models/components/beginresponsebody.js";
import { ListMembersResponseBody } from "../models/components/listmembersresponsebody.js";
import { ListPersonAccountsResponseBody } from "../models/components/listpersonaccountsresponsebody.js";
import { ListResponseBody } from "../models/components/listresponsebody.js";
import { SlackDirectoryConnection } from "../models/components/slackdirectoryconnection.js";
import { SlackDirectoryMember } from "../models/components/slackdirectorymember.js";
import { SyncResponseBody } from "../models/components/syncresponsebody.js";
import {
  BeginSlackDirectoryConnectionRequest,
  BeginSlackDirectoryConnectionSecurity,
} from "../models/operations/beginslackdirectoryconnection.js";
import {
  DisconnectSlackDirectoryConnectionRequest,
  DisconnectSlackDirectoryConnectionSecurity,
} from "../models/operations/disconnectslackdirectoryconnection.js";
import {
  GetSlackDirectoryMemberRequest,
  GetSlackDirectoryMemberSecurity,
} from "../models/operations/getslackdirectorymember.js";
import {
  ListSlackDirectoryConnectionsRequest,
  ListSlackDirectoryConnectionsSecurity,
} from "../models/operations/listslackdirectoryconnections.js";
import {
  ListSlackDirectoryMembersRequest,
  ListSlackDirectoryMembersSecurity,
} from "../models/operations/listslackdirectorymembers.js";
import {
  ListSlackPersonAccountsRequest,
  ListSlackPersonAccountsSecurity,
} from "../models/operations/listslackpersonaccounts.js";
import {
  SetSlackIdentityMappingRequest,
  SetSlackIdentityMappingSecurity,
} from "../models/operations/setslackidentitymapping.js";
import {
  SyncSlackDirectoryRequest,
  SyncSlackDirectorySecurity,
} from "../models/operations/syncslackdirectory.js";
import { unwrapAsync } from "../types/fp.js";

export class SlackDirectoryConnections extends ClientSDK {
  /**
   * begin slackDirectoryConnections
   */
  async begin(
    request: BeginSlackDirectoryConnectionRequest,
    security?: BeginSlackDirectoryConnectionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<BeginResponseBody> {
    return unwrapAsync(slackDirectoryConnectionsBegin(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * disconnect slackDirectoryConnections
   */
  async disconnect(
    request: DisconnectSlackDirectoryConnectionRequest,
    security?: DisconnectSlackDirectoryConnectionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SlackDirectoryConnection> {
    return unwrapAsync(slackDirectoryConnectionsDisconnect(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getMember slackDirectoryConnections
   *
   * @remarks
   * Read current Slack profile and mapping before an administrator confirms a selection.
   */
  async getMember(
    request: GetSlackDirectoryMemberRequest,
    security?: GetSlackDirectoryMemberSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SlackDirectoryMember> {
    return unwrapAsync(slackDirectoryConnectionsGetMember(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * list slackDirectoryConnections
   */
  async list(
    request?: ListSlackDirectoryConnectionsRequest | undefined,
    security?: ListSlackDirectoryConnectionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListResponseBody> {
    return unwrapAsync(slackDirectoryConnectionsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listMembers slackDirectoryConnections
   *
   * @remarks
   * Read observed Slack members across the organization or within one workspace. Does not create identity mappings.
   */
  async listMembers(
    request?: ListSlackDirectoryMembersRequest | undefined,
    security?: ListSlackDirectoryMembersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListMembersResponseBody> {
    return unwrapAsync(slackDirectoryConnectionsListMembers(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listPersonAccounts slackDirectoryConnections
   *
   * @remarks
   * Read mapped Slack accounts for an active organization person by exact Speakeasy user ID. Browser session only; caller must be that person or an organization administrator. Does not infer associations from email or grant permissions.
   */
  async listPersonAccounts(
    request: ListSlackPersonAccountsRequest,
    security?: ListSlackPersonAccountsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListPersonAccountsResponseBody> {
    return unwrapAsync(slackDirectoryConnectionsListPersonAccounts(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setMapping slackDirectoryConnections
   *
   * @remarks
   * Explicitly confirm, reassign or remove a Slack association. This grants no permissions and does not establish runtime eligibility.
   */
  async setMapping(
    request: SetSlackIdentityMappingRequest,
    security?: SetSlackIdentityMappingSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SlackDirectoryMember> {
    return unwrapAsync(slackDirectoryConnectionsSetMapping(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * sync slackDirectoryConnections
   *
   * @remarks
   * Request a complete Slack workspace directory sync. Concurrent requests join the running sync.
   */
  async sync(
    request: SyncSlackDirectoryRequest,
    security?: SyncSlackDirectorySecurity | undefined,
    options?: RequestOptions,
  ): Promise<SyncResponseBody> {
    return unwrapAsync(slackDirectoryConnectionsSync(
      this,
      request,
      security,
      options,
    ));
  }
}
